import SearchFilter from './SearchFilter';
export const searchFilter = {
    init: () => {
        const searchValues = document.querySelectorAll(".search-filter");
        [...searchValues].forEach((el) => new SearchFilter(el));
    },
};

export default searchFilter;